import { axiosInstance } from '../config/axiosConfig';
import { API_ENDPOINTS } from '../endpoints/endpoints';
import {
  RegisterRequest,
  LoginRequest,
  AuthResponse,
  ApiResponse,
} from '../types';

export const authService = {
  register: async (userData: RegisterRequest): Promise<AuthResponse> => {
    const response = await axiosInstance.post<AuthResponse>(
      API_ENDPOINTS.AUTH.REGISTER,
      userData
    );
    return response.data;
  },

  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    const response = await axiosInstance.post<AuthResponse>(
      API_ENDPOINTS.AUTH.LOGIN,
      credentials
    );
    return response.data;
  },

  verifyEmail: async (token: string): Promise<ApiResponse> => {
    const response = await axiosInstance.post<ApiResponse>(
      `${API_ENDPOINTS.AUTH.VERIFY_EMAIL}?token=${token}`
    );
    return response.data;
  },

  resendVerificationToken: async (email: string): Promise<ApiResponse> => {
    const response = await axiosInstance.post<ApiResponse>(
      API_ENDPOINTS.AUTH.RESEND_VERIFICATION,
      { email }
    );
    return response.data;
  },

  requestPasswordReset: async (email: string): Promise<ApiResponse> => {
    const response = await axiosInstance.post<ApiResponse>(
      API_ENDPOINTS.AUTH.REQUEST_PASSWORD_RESET,
      { email }
    );
    return response.data;
  },

  resetPassword: async (
    token: string,
    newPassword: string
  ): Promise<ApiResponse> => {
    const response = await axiosInstance.post<ApiResponse>(
      `${API_ENDPOINTS.AUTH.RESET_PASSWORD}?token=${token}`,
      { newPassword }
    );
    return response.data;
  },

  googleLogin: async (credential: string): Promise<AuthResponse> => {
    const response = await axiosInstance.post<AuthResponse>(
      API_ENDPOINTS.AUTH.GOOGLE_LOGIN,
      { credential, deviceType: 'web' }
    );
    return response.data;
  },

  googleLoginCode: async (code: string): Promise<AuthResponse> => {
    const response = await axiosInstance.post<AuthResponse>(
      API_ENDPOINTS.AUTH.GOOGLE_CODE_LOGIN,
      { code, deviceType: 'web' }
    );
    return response.data;
  },
};
